export default "__VITE_ASSET__BolIL$GC__"